export const RedemptionStatus = {
    Pending: 'pending',
    Disbursed: 'disbursed',
};
